import { Button } from '@magnetic/button'
import { Flex } from '@magnetic/flex'
import { Text } from '@magnetic/text'
import { useAuth } from '@/lib/use-auth'
import { stopImpersonation } from '@/lib/api'
import { invalidateAllConnectQueries } from '@/lib/connect-query-invalidation'
import { Notification } from '@magnetic/notification'
import { useMutationWithToast } from '@/hooks/useMutationWithToast'

export function ImpersonationBanner() {
  const { impersonation, refreshAuth } = useAuth()

  const stopImpersonationMutation = useMutationWithToast(stopImpersonation, {
    successTitle: 'Impersonation stopped',
    successMessage: 'Returned to your account',
    errorTitle: 'Failed to stop impersonation',
    invalidate: invalidateAllConnectQueries,
    onSuccess: async () => {
      await refreshAuth()
    },
  })

  if (!impersonation.isImpersonating) {
    return null
  }

  return (
    <Notification
      banner="page"
      status="warning"
      title={`Impersonating: ${impersonation.impersonatedUser?.name} (${impersonation.impersonatedUser?.email})`}
      onClose={() => stopImpersonationMutation.mutate({})}
    >
      <Flex align="center" justify="space-between">
        <Text size="p4">Original user: {impersonation.originalUser?.name}</Text>
        <Button
          kind="tertiary"
          size="sm"
          onClick={() => stopImpersonationMutation.mutate({})}
          disabled={stopImpersonationMutation.isPending}
          loading={stopImpersonationMutation.isPending}
        >
          Stop Impersonating
        </Button>
      </Flex>
    </Notification>
  )
}
